<template>
    <div class="cursor-pointer">
        <div
            id="blueimp-gallery"
            class="blueimp-gallery blueimp-gallery-controls"
            aria-label="image gallery"
            aria-modal="true"
            role="dialog"
        >
            <div class="slides" aria-live="polite"></div>
            <h3 class="title"></h3>
            <a
                class="prev"
                aria-controls="blueimp-gallery"
                aria-label="previous slide"
                aria-keyshortcuts="ArrowLeft"
            ></a>
            <a
                class="next"
                aria-controls="blueimp-gallery"
                aria-label="next slide"
                aria-keyshortcuts="ArrowRight"
            ></a>
            <a
                class="close"
                aria-controls="blueimp-gallery"
                aria-label="close"
                aria-keyshortcuts="Escape"
            ></a>
            <ol class="indicator"></ol>
        </div>
        <div class="group relative">
            <div class="p-3 w-full absolute hidden group-hover:flex items-center justify-between bg-black/40">
                <div v-if="showMediaManager && canUpload()">
                    <button @click="openMediaManager" type="button" class="btn btn-small btn-orange flex items-center">
                        <inline-svg name="photo" classes="w-4 h-4 text-white fill-current"></inline-svg>
                        <span class="ml-2">Media Manager</span>
                    </button>
                </div>
                <div class="bg-gray-200 text-xs p-2 rounded shadow-md">
                    {{ galleryMedia.length }} {{ galleryMedia.length | pluralize('Picture') }}
                </div>
            </div>
            <img onclick="document.querySelector('#links > a:first-child').click()" class="w-full" :class="objectCover ? 'object-cover' : 'object-contain'" :src="sortedMedia[0].thumbnail" :style="{'max-height': height/1.2 + 'px'}">
        </div>
        <div id="links" class="flex overflow-hidden">
            <a v-for="(media, mediaIndex) in sortedMedia" :key="mediaIndex" :href="media.href" :title="media.title" :data-poster="media.poster">
                <img
                    :class="{ 'hidden': mediaIndex == 0 }"
                    class="mr-1 shadow-md flex-grow-0 flex-shrink-0"
                    :src="media.is_image ? media.href : media.poster"
                    :style="{'width': '100px', 'height': '100px', 'max-width': '100px', 'max-height': '100px'}"
                />
            </a>
        </div>

        <modal name="media-manager" width="60%" height="auto" :click-to-close="false" draggable=".media-manager-title-bar">
            <media-manager
                :documentable-id="documentableId"
                :documentable-type="documentableType"
                :media="galleryMedia"
                :show-upload-button="showUploadButton">
            </media-manager>
        </modal>
    </div>
</template>
 
<script>
    import 'blueimp-gallery/js/blueimp-helper.js';
    import 'blueimp-gallery/js/blueimp-gallery.js';
    import 'blueimp-gallery/js/blueimp-gallery-fullscreen.js';
    import 'blueimp-gallery/js/blueimp-gallery-video.js';

    export default {
        props: {
            documentableId: {
                type: Number,
                required: true
            },

            documentableType: {
                type: String,
                required: true
            },

            media: {
                type: [Array, Object],
                required: true
            },

            height: {
                type: Number,
                required: true
            },

            objectCover: {
                type: Boolean,
                default: true
            },

            showMediaManager: {
                type: Boolean,
                default: true
            },

            showUploadButton: {
                type: Boolean,
                default: true
            },
        },

        mounted() {
            const Gallery = window.blueimp && window.blueimp.Gallery;
            document.getElementById('links').onclick = (event) => {
                event = event || window.event
                var target = event.target || event.srcElement
                var link = target.src ? target.parentNode : target
                var options = { index: link, event: event }
                if (Gallery) Gallery(this.sortedMedia, options)
            }

            this.$eventHub.$on('add-to-gallery', (documents) => {
                this.finalizeUpload(documents);
            });

            this.$eventHub.$on('remove-from-gallery', (url) => {
                this.removeMediaFromGallery(url);
            });
        },

        data() {
            return {
                index: null,
                files: this.media,
                options: {
                    closeOnSlideClick: true
                }
            };
        },

        computed: {
            galleryMedia() {
                return this.files;
            },

            sortedMedia: {
              get() {
                return _.map(_.sortBy(this.galleryMedia, 'sort_order'), (media) => {
                    return {
                        is_image: media.is_image,
                        is_video: media.is_video,
                        title: media.name,
                        type: media.is_image ? 'image/' + media.type : 'video/' + media.type,
                        href: media.view_url,
                        thumbnail: media.is_image ? media.view_url : '/img/video.png',
                        poster: media.is_image ? media.view_url : '/img/video.png'
                    }
                });
              },
              
              set(newValues) {
                this.galleryMedia = newValues;
              }
            }
        },

        methods: {
            canUpload() {
                // Allow if user can edit this specific site or has global create permission
                return this.$gate.can('update','site', this.documentableId) || this.$gate.can('create','site');
            },
            showDocumentUpload() {
                this.$modal.show('media-upload');
            },

            openMediaManager() {
                this.$modal.show('media-manager');
            },

            finalizeUpload(documents) {
                // add new media to gallery
                for (const doc of Object.values(documents)) {
                    if (doc.is_image || doc.is_video) {
                        this.galleryMedia.push(doc);
                    }
                }

                // remove default sample image if it exists
                this.removeMediaFromGallery('/img/temp/building-sample.jpg');
                
                // close modal, filter if required
                this.$modal.hide('media-upload');
                this.$emit('filterRequest');
            },

            removeMediaFromGallery(url) {
                this.files = _.remove(this.files, (item) => {
                    return item.view_url != url;
                });

                if (this.galleryMedia.length == 0) {
                    this.files.push({
                        is_image: true,
                        is_video: false,
                        title: 'Sample Building Photo',
                        type: 'jpg',
                        href: '/img/temp/building-sample.jpg',
                        view_url: '/img/temp/building-sample.jpg',
                        thumbnail: '/img/temp/building-sample.jpg',
                        poster: '/img/temp/building-sample.jpg'
                    });
                }
            }
        }
    }
</script>